const VrUrl = () => {

    let link = '';
    if ( window.location.hostname === 'localhost') {
        // link = 'http://localhost:4200'
        link = 'https://vrgenerator.pietrowicewielkie.com.pl/'
    }else{
        link = 'https://vrgenerator.pietrowicewielkie.com.pl/'
    }

    return link;
}

export default VrUrl;